import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";

const navItems = [
  { to: "/", label: "首页" },
  { to: "/category", label: "同人志分类" },
  { to: "/popular", label: "热门榜单" },
  { to: "/gems", label: "冷门佳作" },
  { to: "/about", label: "关于我们" },
  { to: "/faq", label: "常见问题" },
];

export default function Navbar() {
  const { pathname } = useLocation();
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    setOpen(false);
  }, [pathname]);

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 transition-all duration-300 ${
        scrolled || open
          ? "bg-background-50/90 backdrop-blur-md shadow-sm"
          : "bg-transparent"
      }`}
    >
      <div className="mx-auto flex h-16 max-w-7xl items-center justify-between px-4 md:px-6">
        <Link to="/" className="flex items-center gap-2.5">
          <span className="flex h-9 w-9 items-center justify-center rounded-full bg-primary-500 text-white">
            <i className="ri-book-open-line text-lg"></i>
          </span>
          <span className="font-heading text-xl font-bold tracking-tight text-foreground-900">
            同人志指南
          </span>
        </Link>

        <nav className="hidden items-center gap-1 md:flex" aria-label="主导航">
          {navItems.map((item) => {
            const active = pathname === item.to;
            return (
              <Link
                key={item.to}
                to={item.to}
                className={`whitespace-nowrap rounded-full px-4 py-2 text-sm transition-colors ${
                  active
                    ? "bg-primary-500 text-white"
                    : "text-foreground-700 hover:bg-background-200/70 hover:text-foreground-950"
                }`}
              >
                {item.label}
              </Link>
            );
          })}
          <Link
            to="/category"
            className="ml-2 whitespace-nowrap rounded-full bg-accent-500 px-4 py-2 text-sm font-medium text-white transition-colors hover:bg-accent-600"
          >
            开始探索
          </Link>
        </nav>

        <button
          type="button"
          onClick={() => setOpen((v) => !v)}
          className="flex h-10 w-10 items-center justify-center rounded-full text-foreground-900 md:hidden"
          aria-label={open ? "关闭菜单" : "打开菜单"}
        >
          <i className={open ? "ri-close-line text-2xl" : "ri-menu-line text-2xl"}></i>
        </button>
      </div>

      {open && (
        <nav
          className="border-t border-background-200 bg-background-50 px-4 py-3 md:hidden"
          aria-label="移动端导航"
        >
          <div className="flex flex-col gap-1">
            {navItems.map((item) => {
              const active = pathname === item.to;
              return (
                <Link
                  key={item.to}
                  to={item.to}
                  className={`rounded-lg px-4 py-3 text-sm ${
                    active
                      ? "bg-primary-500 text-white"
                      : "text-foreground-700 hover:bg-background-200/70"
                  }`}
                >
                  {item.label}
                </Link>
              );
            })}
          </div>
        </nav>
      )}
    </header>
  );
}